import React from 'react';
import {Container, FooterLink, WhiteTypography} from './FooterSharedStyles';

const ServiceLinks = () => {
  return (
    <Container>
      <WhiteTypography variant='subheading2' component='span'>
        Service
      </WhiteTypography>
      <FooterLink href='https://support.fupa.net/support/tickets/new' target='_blank'>
        <WhiteTypography variant='body1'>Kontakt</WhiteTypography>
      </FooterLink>
      <FooterLink href='https://support.fupa.net' target='_blank'>
        <WhiteTypography variant='body1'>Hilfebereich</WhiteTypography>
      </FooterLink>
    </Container>
  );
};

export default ServiceLinks;
